import { render, staticRenderFns } from "./InsuranceDetailSkeleton.vue?vue&type=template&id=625b6f2a&scoped=true"
import script from "./InsuranceDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./InsuranceDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDetailSkeleton.vue?vue&type=style&index=0&id=625b6f2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b6f2a",
  null
  
)

export default component.exports